var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.link)?_c('nuxt-link',{class:`button button-${_vm.type}  button-${_vm.size}`,attrs:{"to":_vm.link}},[_vm._t("default")],2):_c('button',{class:`button button-${_vm.type}  button-${_vm.size}`,on:{"click":e => _vm.$emit('click', e)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }